module.exports = __webpack_public_path__ + "img/logo-grupo_2024.c0038504.png";